// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1jkDr","inputWrap":"Table_inputWrap__2S1Af","col":"Table_col__3yj1t","bmiTooltip":"Table_bmiTooltip__3Sdyb"};